// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-data-table thead {
  color: #fff;
}
.app-data-table thead th {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-weight: normal;
}
.app-data-table thead th .table-filter-dropdown-menu-con .dropdown-menu .dropdown-item.active,
.app-data-table thead th .table-filter-dropdown-menu-con .dropdown-menu .dropdown-item:active {
  background: #2795ae;
  color: white;
}
.app-data-table tbody tr * {
  background-color: transparent;
  color: #40393a;
  vertical-align: middle;
}
.app-data-table tbody .colomn-width-limit {
  max-width: 200px;
  white-space: break-spaces;
  word-break: break-all;
}
.app-data-table tbody .colomn-width-limit-anchor-tag {
  width: 200px;
  white-space: break-spaces;
  word-break: break-all;
  display: block;
}

.data-table-head {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.data-table-head.sortable {
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}
.data-table-head i {
  margin-left: 1px;
  font-size: 15px;
}
.data-table-head i.bx-sort {
  opacity: 0.5;
}
.data-table-head .filter-value {
  font-size: 10px;
  margin-left: 3px;
  font-style: italic;
  color: #2795ae;
}

.cursor-pointer {
  cursor: pointer;
}

.table-min-height {
  min-height: 350px;
}

.table-loader-container {
  height: 340px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.column-filter-menu {
  font-size: 20px;
  cursor: pointer;
}

.column-filter-item {
  padding-top: 6px;
  padding-bottom: 6px;
}
.column-filter-item label,
.column-filter-item input {
  cursor: pointer;
}

.column-filter-item:not(:last-child) {
  border-bottom: 1px solid #eee;
}

span.column-title {
  font-weight: 700;
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/components/DataTable/DataTable.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAEQ;EACI,wCAAA;EACA,2CAAA;EAYA,mBAAA;AAXZ;AAcoB;;EAEI,mBAAA;EACA,YAAA;AAZxB;AA6BQ;EACI,6BAAA;EACA,cAAA;EACA,sBAAA;AA3BZ;AA6BQ;EACI,gBAAA;EACA,yBAAA;EACA,qBAAA;AA3BZ;AA6BQ;EACI,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AA3BZ;;AA+BA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA5BJ;AA8BI;EACI,yBAAA;UAAA,iBAAA;EACA,eAAA;AA5BR;AA+BI;EACI,gBAAA;EACA,eAAA;AA7BR;AA+BQ;EACI,YAAA;AA7BZ;AAiCI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AA/BR;;AAmCA;EACI,eAAA;AAhCJ;;AAmCA;EACI,iBAAA;AAhCJ;;AAmCA;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAhCJ;;AAmCA;EACI,eAAA;EACA,eAAA;AAhCJ;;AAmCA;EACI,gBAAA;EACA,mBAAA;AAhCJ;AAiCI;;EAEI,eAAA;AA/BR;;AAmCA;EACI,6BAAA;AAhCJ;;AAmCA;EACI,gBAAA;EACA,WAAA;AAhCJ","sourcesContent":[".app-data-table {\n    thead {\n        color: #fff;\n\n        th {\n            border-top: 1px solid rgba(0, 0, 0, 0.1);\n            border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n            // Commented these because not needed in the current project\n\n            // &:first-child {\n            //     border-top-left-radius: 4px;\n            //     border-bottom-left-radius: 4px;\n            // }\n            // &:last-child {\n            //     border-top-right-radius: 4px;\n            //     border-bottom-right-radius: 4px;\n            // }\n            font-weight: normal;\n            .table-filter-dropdown-menu-con {\n                .dropdown-menu {\n                    .dropdown-item.active,\n                    .dropdown-item:active {\n                        background: #2795ae;\n                        color: white;\n                    }\n                }\n            }\n        }\n    }\n    tbody {\n        // Commented these because not needed in the current project\n        // This makes the rows bigger\n\n        // tr {\n        //     transition: all 0.3s;\n        //     &:hover {\n        //         box-shadow: -7px 0px 30px #00000029;\n        //     }\n        // }\n\n        tr * {\n            background-color: transparent;\n            color: #40393a;\n            vertical-align: middle;\n        }\n        .colomn-width-limit {\n            max-width: 200px;\n            white-space: break-spaces;\n            word-break: break-all;\n        }\n        .colomn-width-limit-anchor-tag {\n            width: 200px;\n            white-space: break-spaces;\n            word-break: break-all;\n            display: block;\n        }\n    }\n}\n.data-table-head {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n\n    &.sortable {\n        user-select: none;\n        cursor: pointer;\n    }\n\n    & i {\n        margin-left: 1px;\n        font-size: 15px;\n\n        &.bx-sort {\n            opacity: 0.5;\n        }\n    }\n\n    & .filter-value {\n        font-size: 10px;\n        margin-left: 3px;\n        font-style: italic;\n        color: #2795ae;\n    }\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.table-min-height {\n    min-height: 350px;\n}\n\n.table-loader-container {\n    height: 340px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.column-filter-menu {\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.column-filter-item {\n    padding-top: 6px;\n    padding-bottom: 6px;\n    label,\n    input {\n        cursor: pointer;\n    }\n}\n\n.column-filter-item:not(:last-child) {\n    border-bottom: 1px solid #eee;\n}\n\nspan.column-title {\n    font-weight: 700;\n    color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
